import React, { FC } from 'react';
import 'twin.macro';
import { Link } from 'gatsby';
import { useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Appbar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import { styled, useTheme } from '@mui/material/styles';

import Menu from './Menu';
import MenuMobile from './MenuMobile';
import useMainIsTop from 'src/hooks/useIsTop';

const Root = styled(Appbar)(() => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
}));

const StyledAppBar = styled(Appbar)<{ mode: 'transparent' | 'fill' }>(({ theme, mode }) => ({
  boxShadow: '0 0 black',
  padding: '28px 0',
  backgroundColor:
    (mode === 'fill') && typeof window !== 'undefined'&& window.location.pathname.length < 2
      ? `rgba(255,255,255,0.3)`
      : 'transparent',
  color: theme.palette.common.black,
  backdropFilter: (mode === 'fill') ? 'saturate(180%) blur(20px)' : 'null',
  position: 'relative',
  // top: '100px',
  transition:
    'transform 0.5s ease-out, box-shadow 0.3s ease-out, background-color 0.3s ease-out;',

  [theme.breakpoints.down('lg')]: {
    padding: '18px 0',
    width: '100%',
    // top: '60px',
  },
}));

const Logo = styled('img')(({ theme }) => ({
  width: 186,
  height: 40,
  [theme.breakpoints.down('md')]: {
    width: 160,
    height: 36,
  },
}));

const Button = styled('button')(({ theme }) => ({
  border: '1px solid #FFF',
  borderRadius: '44px',
  padding: '14px 32px',
  color: '#FFF',
  fontSize: '16px',
  fontWeight: '500',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));


const Header: FC = () => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { isTop } = useMainIsTop();
  return (
    <Root>
      <StyledAppBar mode={isTop ? 'transparent' : 'fill'}>
        <Container>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Link to="/">
                {isTop && typeof window !== 'undefined' && window.location.pathname.length < 2 ? (
                  <Logo
                    src="/logos/img-header-logo-white.svg"
                    alt="hyperconnect career"
                  />
                ) : (
                  <Logo
                    src="/logos/img-header-logo.svg"
                    alt="hyperconnect career"
                  />
                )}
              </Link>
            </Grid>
            <Grid item>
              {lgUp ? (
                <Typography component="span" variant="caption">
                  <Menu />
                </Typography>
              ) : (
                <MenuMobile />
              )}
            </Grid>
          </Grid>
        </Container>
      </StyledAppBar>
    </Root>
  );
};

export default Header;
